import {
	Selectable,
	Screenshot,
	Rating,
	CustomThumbSelectable
} from '@/features/elements';
import { SvgIcon } from '@/features/form';
import { useConfigStore } from '@/features/form';

import Text from './Text';

function getAnswerValue(value, block) {
	switch (block.typeName) {
		case 'radio':
		case 'gcr':
		case 'category':
			const radioGcrValue = Object.keys(block.properties.elements).reduce(
				(returnValue, elementKey) => {
					const el = block.properties.elements[elementKey];
					if (el.value && el.value == value) {
						returnValue = el.label ? el.label : el.value;
					}
					return returnValue;
				},
				''
			);

			return radioGcrValue ? radioGcrValue : value;

		case 'ces':
			if (block.properties.elements[value]) {
				return block.properties.elements[value]?.label;
			} else {
				return value;
			}

		case 'rating':
			if (block.properties.showCaptions) {
				return block.properties?.elements?.[value]?.label ?? value;
			}
			return value;

		default:
			return '';
	}
}

export default function Answer({ element, block, value, state, ...props }) {
	const { text } = useConfigStore();
	if (state.isSkipped) {
		return <Text text={text?.skipText ?? 'Skip'} />;
	}

	switch (block.typeName) {
		case 'gcr':
		case 'radio':
		case 'ces':
		case 'category':
			return (
				<Text
					block={block}
					text={getAnswerValue(value, block)}
				/>
			);

		case 'thumbs':
			const customThumb = block?.thumbs?.[value] ?? {};

			const thumbsElement = Object.keys(block.properties.elements).reduce(
				(returnObj, currentKey) => {
					const el = block.properties.elements[currentKey];
					if (el.value && el.value == value) {
						returnObj = { ...el, key: currentKey };
					}
					return returnObj;
				},
				{}
			);

			if (['img', 'svg'].indexOf(customThumb.type) > -1) {
				return (
					<CustomThumbSelectable
						block={block}
						customThumb={customThumb}
						checked
						tabIndex="-1"
						role="none"
						selectableIndex={Number(thumbsElement.key)}
					/>
				);
			}

			return (
				<Selectable
					block={block}
					checked
					tabIndex="-1"
					role="none"
					labelAtts={{
						class: `label_thumbs_${
							Number(thumbsElement.key) === 1 ? 'positive' : 'negative'
						}`,
						title: `${Number(thumbsElement.key) === 1 ? 'positive' : 'negative'}`
					}}
					selectableIndex={Number(thumbsElement.key)}
				>
					<SvgIcon
						icon={thumbsElement.icon}
						alt={`${
							Number(thumbsElement.key) === 1 ? 'positive' : 'negative'
						} thumb icon`}
					/>
				</Selectable>
			);

		case 'screenshot':
			return (
				<Screenshot
					block={block}
					state={state}
				/>
			);

		case 'rating':
			if (block.properties?.type === 'emoji') {
				return (
					<Rating
						block={block}
						state={state}
						showScoreOnly
						role="none"
						disabled
					/>
				);
			}
			return (
				<Text
					block={block}
					text={getAnswerValue(value, block)}
				/>
			);

		default:
			return (
				<Text
					block={block}
					text={value}
				/>
			);
	}
}
